import React from 'react';
import { useHistory } from 'react-router-dom';
import AuthFlow from '../../components/AuthFlow';

const AuthPage = (props) => {
  const history = useHistory()

  return(
    <AuthFlow 
      props={{
        quickSignup: false,
      //   modal: true,
      //   modalOpen: true,
        title: "Create your free account",
        subtitle: "100% free. No credit card needed.",
        onAuthenticated: () => history.push("/workflows")
      }}
    />
  )
}

export default AuthPage